<carm-card class="carm-widget carm-transaction-widget">
  <carm-card-title>
    <div class="row">
      <div
      class="col-xs-7 col-sm-6 inline-content"
      data-cy="recent-transactions">
        <span>{{
          'dashboard.widgets.recent_transactions.title' | translate
        }}</span>
        <carm-popover class="mrgn-lft-sm mrgn-tp-sm">
          {{ 'dashboard.widgets.recent_transactions.tooltip' | translate }}
        </carm-popover>
      </div>
      <div class="col-xs-5 col-sm-6 text-right">
        <a
        [carmRouterLink]="viewAllUrl"
        data-cy="view-all-transactions"
          ><em>{{
            'dashboard.widgets.recent_transactions.viewAllTransactions'
              | translate
          }}</em></a
        >
      </div>
    </div>
  </carm-card-title>
  <carm-card-content>
    <ng-container *ngIf="!loading">
      <div class="recent-transactions-content">
        <carm-ag-grid
          *ngIf="transactions && transactions.length > 0"
          [agGridConfig]="agGridConfig"
          [dataSource]="transactions"
          [itemPageSize]="false"
          [autoHeight]="false"
          [enablePagination]="false"
          inId="RecentTransactions"
        ></carm-ag-grid>
        <div *ngIf="!transactions || transactions.length === 0">
          <em>{{
            'dashboard.widgets.recent_transactions.noRecentTransactions'
              | translate
          }}</em>
        </div>
      </div>
    </ng-container>
    <div *ngIf="loading">
      <mat-progress-spinner
        attr.aria-label="{{ 'application_features.loading' | translate }}"
        class="mat-spinner-color spinner-position"
        mode="indeterminate"
        value="50"
      >
      </mat-progress-spinner>
    </div>
  </carm-card-content>
</carm-card>
